import get from 'lodash/get'

export const chooseIconColor = (type, theme, functionName) => {
  if (typeof get(theme, `notification.icon.${functionName}`) === 'function') {
    return theme.notification.icon[functionName](type)
  }

  return '#FFFFFF'
}
